module.exports = __webpack_public_path__ + "static/media/green.68d1930f.svg";